import { renderTooltip } from "./shared";

export function csatTooltip(item) {
  // Parse the options array from JSON string
  let options = [];
  try {
    options = JSON.parse(item.options || "[]");
  } catch (e) {
    console.error("Failed to parse CSAT options:", e);
    options = [];
  }

  // Define the scale items for CSAT (1-5 positions)
  const scaleItems = [
    { index: 0, countField: "one_position_count" },
    { index: 1, countField: "two_position_count" },
    { index: 2, countField: "three_position_count" },
    { index: 3, countField: "four_position_count" },
    { index: 4, countField: "five_position_count" },
  ];

  return renderTooltip(
    {
      itemTypeLabel: "Internal Tool",
      surveyText: item.prompt,
      scoringMethod: "CSAT Score",
      scaleItems,
      options,
    },
    item,
    "sample_size",
  );
}
